import React from 'react';
import classNames from 'classnames';
import { useTranslation } from "../../../../hooks/useTranslation";
import { makeStyles, Card, CardContent } from "../../../../index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        transition: '0.3s',
        boxShadow: 'none',
        borderStyle: 'solid',
        borderWidth: theme.shape.borderWidth.normal,
        borderRadius: theme.shape.borderRadius,
        borderColor: theme.palette.light.text.primary,
        '&:hover:not($readonly)': {
            // TODO VDと確認。あえて別の色を指定している。
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary[50],
        },
        '&:active:not($readonly)': {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary[700],
        },
        '&$selected': {
            color: theme.palette.dark.text.primary,
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main,
        },
        '&$selected:hover:not($readonly)': {
            backgroundColor: theme.palette.primary[200],
        },
        '&$selected:active:not($readonly)': {
            backgroundColor: theme.palette.primary[700],
        },
    },
    selected: {},
    readonly: {
        cursor: 'default',
    },
}); });
export var DummyUserSelectCard = React.memo(function () {
    return React.createElement("div", { style: { width: 168, height: 0, opacity: 0 } });
});
export var UserSelectCard = React.memo(function (props) {
    var _a;
    var user = props.user, selected = props.selected, readonly = props.readonly, onClick = props.onClick;
    var nameDisplay = useTranslation().nameDisplay;
    var classes = useStyles();
    var className = classNames(classes.root, (_a = {},
        _a[classes.selected] = selected,
        _a[classes.readonly] = readonly,
        _a));
    var handleClick = function () {
        if (readonly)
            return;
        onClick === null || onClick === void 0 ? void 0 : onClick(user, !!selected);
    };
    var userName = nameDisplay === 'ruby' ? user.ruby || user.name : user.name;
    return (React.createElement(Card, { className: className, width: 168, onClick: handleClick, 
        // @ts-ignore 名前が省略されることがあるので、`title`属性に渡してホバー時に表示する
        title: userName },
        React.createElement(CardContent, { trancated: true }, userName)));
});
